<template>
    <div class="main">
        <c-panel title="MUNICÍPIOS ASSOCIADOS" titleIcon="fas fa-city">
            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Municípios que consomem o catálogo desta instalação gestora."
                description="Cada município recebe um token próprio, exibido uma única vez. É com ele que a instalação do município lê o catálogo central."></el-alert>

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10" class="u-mb-15">
                    <el-col :xs="24" :sm="14">
                        <el-form-item label="Consórcio" class="u-mb-0">
                            <el-select v-model="consorcioId" filterable style="width: 100%;" @change="carregar">
                                <el-option v-for="c in consorcios" :key="c.id" :value="c.id"
                                    :label="c.nome + (c.municipio_gestor ? ' (gestor)' : ' (associado)')"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="10" class="u-text-right u-mt-25">
                        <el-button v-if="podeEscrever" type="primary" size="small" icon="el-icon-plus"
                            :disabled="!consorcioId" @click="abrirNovo">ASSOCIAR MUNICÍPIO</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <div v-if="dados" class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Município</th>
                            <th style="width: 130px;">Código IBGE</th>
                            <th class="hidden-mobile">URL da API</th>
                            <th style="width: 150px;" class="u-text-center">Último acesso</th>
                            <th style="width: 100px;" class="u-text-center">Situação</th>
                            <th style="width: 190px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="m in dados.itens" :key="m.id">
                            <td>{{ m.nome }}</td>
                            <td>{{ m.codigo_ibge }}</td>
                            <td class="hidden-mobile">{{ m.url_api || '—' }}</td>
                            <td class="u-text-center">{{ m.ultimo_acesso ? dataHora(m.ultimo_acesso) : 'nunca' }}</td>
                            <td class="u-text-center">
                                <el-tag size="mini" :type="m.situacao ? 'success' : 'info'">{{ m.situacao ? 'Ativo' : 'Inativo' }}</el-tag>
                            </td>
                            <td class="u-text-center acao">
                                <el-button v-if="podeEscrever" size="mini" plain @click="regerar(m)">TOKEN</el-button>
                                <el-button class="u-ml-10" v-if="podeEscrever" size="mini" type="info" plain icon="el-icon-edit" @click="abrirEdicao(m)"></el-button>
                                <el-button class="u-ml-10" v-if="podeEscrever" size="mini" type="danger" plain icon="el-icon-delete" @click="excluir(m)"></el-button>
                                <span v-if="!podeEscrever">—</span>
                            </td>
                        </tr>
                        <tr v-if="dados.itens.length === 0"><td colspan="6" class="u-text-center">Nenhum município associado.</td></tr>
                    </tbody>
                </table>
            </div>

            <el-alert v-else type="info" :closable="false" title="Selecione o consórcio."></el-alert>

            <!-- ==================== FORMULÁRIO ==================== -->
            <el-dialog :title="form.id ? 'Editar município' : 'Associar município'" :visible.sync="dialogo" width="560px">
                <el-form label-position="top">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="14">
                            <el-form-item label="Nome do município">
                                <el-input v-model="form.nome" placeholder="Timbé do Sul"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="10">
                            <el-form-item label="Código IBGE">
                                <el-input v-model="form.codigo_ibge" v-mask="'#######'" :disabled="!!form.id"
                                    placeholder="4218202"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="URL da API do município (opcional)">
                        <el-input v-model="form.url_api" placeholder="https://municipio.sc.gov.br/api"></el-input>
                    </el-form-item>
                    <el-form-item label="Situação">
                        <el-switch v-model="form.situacao" active-text="Ativo" inactive-text="Inativo"></el-switch>
                    </el-form-item>
                </el-form>
                <span slot="footer">
                    <el-button @click="dialogo = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="primary" :disabled="!form.nome || !form.codigo_ibge" @click="salvar">SALVAR</el-button>
                </span>
            </el-dialog>

            <!-- ==================== TOKEN — uma vez ==================== -->
            <el-dialog title="Token do município" :visible.sync="dialogoToken" width="620px" :close-on-click-modal="false">
                <el-alert type="warning" :closable="false" class="u-mb-15"
                    title="Entregue este token ao município agora." :description="avisoToken"></el-alert>
                <el-input v-model="tokenGerado" readonly>
                    <el-button slot="append" icon="el-icon-document-copy" @click="copiar">COPIAR</el-button>
                </el-input>
                <small class="u-text-muted">
                    O município configura este valor no cadastro do consórcio, no campo "Token de acesso".
                </small>
                <span slot="footer"><el-button type="primary" @click="dialogoToken = false">JÁ COPIEI</el-button></span>
            </el-dialog>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO M — itens 123 e 124: municípios associados. */
export default {
    data: () => ({
        consorcioId: null, consorcios: [], dados: null,
        dialogo: false, dialogoToken: false, tokenGerado: '', avisoToken: '',
        form: { id: null, nome: '', codigo_ibge: '', url_api: '', situacao: true }
    }),
    computed: {
        podeEscrever () { return [4, 5].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () {
        this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/consorcio/getAllPaginate?page=1`,
            {}, this.$store.getters.getHeaderAuth
        ).then(r => {
            this.consorcios = r.data.data || []
            if (this.$route.query.consorcio) this.consorcioId = parseInt(this.$route.query.consorcio)
            else if (this.consorcios.length) this.consorcioId = this.consorcios[0].id
            if (this.consorcioId) this.carregar()
        }).catch(e => this.$store.commit('throwException', e))
    },
    methods: {
        carregar () {
            this.dados = null
            if (!this.consorcioId) return

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/municipio-consorciado/getByConsorcio/${this.consorcioId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                this.dados = r.data
            }).catch(e => this.$store.commit('throwException', e))
        },
        abrirNovo () {
            this.form = { id: null, nome: '', codigo_ibge: '', url_api: '', situacao: true }
            this.dialogo = true
        },
        abrirEdicao (m) {
            this.form = { id: m.id, nome: m.nome, codigo_ibge: m.codigo_ibge,
                          url_api: m.url_api || '', situacao: !!m.situacao }
            this.dialogo = true
        },
        salvar () {
            const url = this.form.id
                ? `${this.$store.state.config.baseUrlApi}/api/municipio-consorciado/update/${this.form.id}`
                : `${this.$store.state.config.baseUrlApi}/api/municipio-consorciado/store`

            const payload = Object.assign({}, this.form, { consorcio_id: this.consorcioId })

            this.$axios.post(url, payload, this.$store.getters.getHeaderAuth).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }

                this.dialogo = false
                this.carregar()

                // Na criação o token aparece uma única vez.
                if (r.data.token) {
                    this.tokenGerado = r.data.token
                    this.avisoToken = r.data.aviso_token
                    this.dialogoToken = true
                    return
                }

                window.eventBus.$emit('alert', { msg: r.data.mensagem, type: 'success' })
            }).catch(e => this.$store.commit('throwException', e))
        },
        regerar (m) {
            this.$confirm(`Gerar um token novo para "${m.nome}"? O token atual deixa de funcionar imediatamente.`,
                'Confirmação', { confirmButtonText: 'Gerar novo', cancelButtonText: 'Cancelar', type: 'warning' }
            ).then(() => {
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/municipio-consorciado/regerarToken/${m.id}`,
                    {}, this.$store.getters.getHeaderAuth
                ).then(r => {
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    this.tokenGerado = r.data.token
                    this.avisoToken = 'Entregue o token novo ao município. O anterior deixou de funcionar.'
                    this.dialogoToken = true
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        excluir (m) {
            this.$confirm(`Remover "${m.nome}" do consórcio?`, 'Confirmação', {
                confirmButtonText: 'Remover', cancelButtonText: 'Cancelar', type: 'warning'
            }).then(() => {
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/municipio-consorciado/delete/${m.id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: r.data.mensagem, type: 'success' })
                    this.carregar()
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        copiar () {
            const el = document.createElement('textarea')
            el.value = this.tokenGerado
            document.body.appendChild(el)
            el.select()
            document.execCommand('copy')
            el.remove()
            window.eventBus.$emit('alert', { msg: 'Token copiado.', type: 'success' })
        },
        dataHora (d) {
            if (!d) return '—'
            const p = d.substring(0, 10).split('-')
            return `${p[2]}/${p[1]}/${p[0]} ${d.substring(11, 16)}`
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
